export const SUBMITTING_ORDER = "SUBMITTING_ORDER";
export const SUBMITTED_ORDER = "SUBMITTED_ORDER";
export const CHANGE_SEND_MESSAGE_STATUS = "CHANGE_SEND_MESSAGE_STATUS";
